import { Utensils } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import OrderTypeLabel from './OrderTypeLabel';
import useTableOrder from '../../hooks/order/useTableOrder';
import useOrderMethodsStatus from '../../hooks/availability/useOrderMethodsStatus';
import useTheme from '../../hooks/ui/useTheme';
import { ORDER_METHODS } from '../../services/exports/Constants';

interface Props {
  className?: string;
  /** Called after the guest switched to pickup, e.g. to move focus to the toggle. */
  onLeave?: () => void;
}

/**
 * At a table: "Table ordering" in place of the toggle, and "Pickup or delivery" to leave it, where the
 * restaurant offers either (one can take table orders only).
 */
export default function TableOrderLabel({ className, onLeave }: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:OrderType:TableOrdering' });
  const { leaveTable } = useTableOrder();
  const { enabledOrderMethods, visibleOrderMethods } = useOrderMethodsStatus();
  const theme = useTheme();
  // Where the guest lands: pickup, or delivery where the restaurant hides or doesn't take pickup. A
  // method that is on but hidden has no tab to show the cart in.
  const leaveTarget = [ORDER_METHODS.PICKUP, ORDER_METHODS.DELIVERY].find(
    (method) => visibleOrderMethods.includes(method) && enabledOrderMethods.includes(method),
  );

  return (
    <OrderTypeLabel
      className={className}
      icon={<Utensils aria-hidden="true" className="h-[18px] w-[18px] shrink-0" color={theme.color.brand.primary} />}
      label={t('table_ordering')}
      action={
        leaveTarget
          ? {
              label: t('pickup_or_delivery'),
              onClick: () => {
                leaveTable(leaveTarget);
                onLeave?.();
              },
            }
          : undefined
      }
    />
  );
}
